module.exports = __webpack_public_path__ + "static/media/hero_mobile.5357b09f.webp";